module.exports = __webpack_public_path__ + "static/media/euro.f132567f.svg";